<template>
  <div class="wrapper">
    <div class="user_bg">
      <div class="user_list">
        <span>
          <span>患者姓名</span>
          {{ report.patientName }}（{{ report.sex == "M"?"男":"女" }}）
        </span>
        <span>
          <span>患者编号</span>
          就诊ID号&nbsp;&nbsp;
          {{ report.patientId }}
        </span>
      </div>
    </div>
    <div class="jcsj">
      <div class="title">检查所见</div>
      <div class="result">{{ jyreport.lstItemResult[0].ItemPromt }}</div>
    </div>
    <div class="jcts">
      <div class="title">检查提示</div>
      <div class="result">{{ jyreport.lstItemResult[0].ItemResult }}</div>
    </div>
    <div class="foot">
      <span>
        <span>报告医生</span>
        <span>{{ jyreport.Reviewer }}</span>
      </span>
      <span>
        <span>报告时间</span>
        <span>{{ jyreport.InspectionTime }}</span>
      </span>
      <span>
        <span>报告编号</span>
        <span>{{ jyreport.LabNo }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import { GetCkLabDtlResult } from "@/request/api.js";
export default {
  data() {
    return {
      report: {},
      jyreport: {}
    }
  },
  created() {
    this.report = JSON.parse(sessionStorage.getItem("report"));
    this.getjyReport();
  },
  methods: {
    async getjyReport(){
      let map = {
        billNo: this.report.billNo,
        type: this.report.applyType,
        userID: "7148"
      }
      let res = await GetCkLabDtlResult(map);
      if(res.data.ResultData != null){
        this.jyreport = res.data.ResultData[0];
        this.jyreport.AudiTime = this.jyreport.AudiTime.replace(/\-/g, "/")
      } else {
        this.Toast(res.data.ResultMsg)
      }
    }
  },
}
</script>

<style lang="less" scoped>
  .wrapper {
    width: 100%;
    height: 100%;
    overflow: auto;
    background: #f8f8f8;
    .user_bg{
      background: white;
      padding: 16px;
      .user_list{
        background: #e6f5fc;
        border-radius: 4px;
        display: flex;
        flex-flow: column nowrap;
        padding: 16px 10px;
        font-size: 16px;
        >span{
          >span{
            font-weight: bold;
            letter-spacing: 1px;
            color: #888;
            margin-right: 6px;
          }
        }
        >span:nth-child(1){
          margin-bottom: 6px;
        }
      }
    }
    .jcsj, .jcts{
      margin-top: 10px;
      background: white;
      .title{
        letter-spacing: 1px;
        padding: 12px 16px;
        font-weight: bold;
        font-size: 16px;
        border-bottom: 1px solid #ddd;
      }
      .result{
        text-indent: 2em;
        line-height: 22px;
        letter-spacing: 1px;
        color: #666;
        font-size: 14px;
        padding: 12px 16px;
      }
    }
    .foot{
      margin-top: 10px;
      background: white;
      padding: 16px;
      display: flex;
      flex-flow: column nowrap;
      font-size: 16px;
      >span{
        >span:nth-child(1){
          font-weight: bold;
          letter-spacing: 1px;
          color: #888;
          margin-right: 6px;
        }
      }
      >span:nth-child(2){
        margin: 6px 0px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/Index/Report/screenReportetails.vue